import {
  State,
  SetDecisionPayload as Payload,
} from "components/bookShuffle/useBookShuffle/types";

/**
 * Sets the user's preference for the book
 */
export function setDecision(state: State, payload: Payload): State {
  const { preferenceValue, showAcceptedDialog, showRejectedDialog } = payload;
  const { currentIndex } = state;

  // set the preference value for the current book
  const books = [...state.books];
  books[currentIndex] = {
    ...books[currentIndex],
    preferenceValue,
  };

  return {
    ...state,
    books,
    currentIndex: currentIndex + 1,
    isAnimating: true,
    showAcceptedDialog,
    showRejectedDialog,
  };
}
